import {
  createBoldPlugin,
  createCodePlugin,
  createItalicPlugin,
  createStrikethroughPlugin,
  createUnderlinePlugin
} from '@udecode/plate-basic-marks';
import { createBlockquotePlugin } from '@udecode/plate-block-quote';
import { Plate, PlateProvider, TEditableProps, Value, createPlugins } from '@udecode/plate-common';
import { createHeadingPlugin } from '@udecode/plate-heading';
import { createParagraphPlugin } from '@udecode/plate-paragraph';

import { FixedToolbar } from '@/components/editor/fixed-toolbar';
import { FixedToolbarButtons } from '@/components/editor/fixed-toolbar-buttons';
import { createPlateUI } from '@/lib/create-plate-ui';
import { cn } from '@/lib/utils';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import { FC } from 'react';
import { InputProps, withField } from '../withField';

const plugins = createPlugins(
  [
    createParagraphPlugin(),
    createBlockquotePlugin(),
    createHeadingPlugin(),

    createBoldPlugin(),
    createItalicPlugin(),
    createUnderlinePlugin(),
    createStrikethroughPlugin(),
    createCodePlugin()
  ],
  {
    components: createPlateUI()
  }
);

interface RichTextInputProps {
  placeholder?: string;
  containerClassName?: string;
}

export const RichTextInput: FC<InputProps<Value> & RichTextInputProps> = ({ onChange, value, containerClassName }) => {
  return (
    <TooltipProvider disableHoverableContent delayDuration={500} skipDelayDuration={0}>
      <PlateProvider plugins={plugins} value={value} onChange={onChange}>
        <div className={cn('relative flex w-full select-none flex-col', containerClassName)}>
          <FixedToolbar>
            <FixedToolbarButtons />
          </FixedToolbar>
          <Plate
            editableProps={
              {
                className: cn('relative max-w-full leading-[1.4] outline-none [&_strong]:font-bold bg-white', 'p-8')
              } as TEditableProps
            }
          />
        </div>
      </PlateProvider>
    </TooltipProvider>
  );
};

export const RichTextField = withField<Value, RichTextInputProps>(RichTextInput);
